<template>
  <div class="mt-1 mb-1">
    <textarea
      :id="id"
      class="form-control" 
      :class="classState"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      rows="1"
      @blur="emitFocusOut"
      @keyup.enter="emitFocusOut"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "BaseTextArea",
  ////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////
  props: {
    id: [Number, String],
    modelValue: String,
    classState: String,
    focusOutEnabled: {
      type: Boolean,
      default: true
    },
  },
  ////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////
  methods: {
    emitInputChanged: function(event) {
      if (this.focusOutEnabled)
        return;
      
      this.$emit('InputChanged', { id: this.id, value: event.target.value });
    },
    ////////////////////////////////////////////////////////////////
    emitFocusOut: function(event) {
      if (!this.focusOutEnabled)
        return;

      this.$emit('InputChanged', { id: this.id, value: event.target.value });
    },
  }
}
</script>

<style lang="scss">
  .textArea-trinnov, .textArea-trinnov:focus {
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px 4px 0px 0px;
    background: #29292D;
    color: $white;
    font-size: 2vh;
  }
</style>